<template>
    <div class="Scenes" id="application">
        <div class="Scenes-after"></div>
        <h2 class="common-title common-title1">Desktron云桌面应用场景</h2>

        <van-tabs
            color="#0C89E4"
            title-active-color="#0C89E4"
            title-inactive-color="#1D2129"
            swipe-threshold="4"
            v-model="active"
            background="transparent"
            swipeable
        >
            <van-tab v-for="item in content" :key="item.key">
                <template #title>
                    <div class="Scenes-item">
                        <img
                        class="Scenes-item-img"
                        :src="item.key === active ? item.active : item.icon"
                        />
                        {{ item.tabTitle }}
                    </div>
                </template>
                <img :src="item.pic" class="Scenes-right" />
                <div class="Scenes-left">
                    <h3 class="Scenes-title">{{ item.title }}</h3>
                    <ul class="Scenes-list1">
                        <li
                            v-for="(item, index) in item.list1"
                            :key="index"
                            class="Scenes-item1"
                        >
                            {{ item }}
                        </li>
                    </ul>
                    <h3 class="Scenes-title">优势</h3>
                    <ul class="Scenes-list2">
                        <li
                            v-for="(item, index) in item.list2"
                            :key="index"
                            class="Scenes-item2"
                        >
                            {{ item }}
                        </li>
                    </ul>
                </div>
            </van-tab>
        </van-tabs>
        <a class="btn-common btn-primary dt-btn" @click="handleClick">申请试用</a>
    </div>
</template>

<script>
import { Tabs, Tab } from "vant";
import pic1 from "@/assets/desktron/Scenes/pic1.png";
import pic2 from "@/assets/desktron/Scenes/pic2.png";
import pic3 from "@/assets/desktron/Scenes/pic3.png";
import pic4 from "@/assets/desktron/Scenes/pic4.png";
import pic5 from "@/assets/desktron/Scenes/pic5.png";

import icon11 from "@/assets/desktron/Scenes/icon1.png";
import icon22 from "@/assets/desktron/Scenes/icon2.png";
import icon33 from "@/assets/desktron/Scenes/icon3.png";
import icon44 from "@/assets/desktron/Scenes/icon4.png";
import icon55 from "@/assets/desktron/Scenes/icon5.png";
import icon1Active from "@/assets/desktron/Scenes/icon1-active.png";
import icon2Active from "@/assets/desktron/Scenes/icon2-active.png";
import icon3Active from "@/assets/desktron/Scenes/icon3-active.png";
import icon4Active from "@/assets/desktron/Scenes/icon4-active.png";
import icon5Active from "@/assets/desktron/Scenes/icon5-active.png";

export default {
    components: {
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
    },
    props: {
        path: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            content: Object.freeze([
                {
                    key: 0,
                    tabTitle: "高性能场景",
                    icon: icon11,
                    active: icon1Active,
                    title: "设计、制图、视频编辑等图形制作渲染场景",
                    list1: [
                        "适用于专业图形设计（如CAD/SolidWorks/Revit等）、视频动画制作、图形渲染等场景，广泛应用于工业设计、建筑设计、勘察设计、游戏开发、影视剪辑等涉及高性能场景的行业。 ",
                        "在专业设计领域，需要有GPU支持的桌面提供性能保障，在关注操控的流畅性的同时，也关注设计成果的数据安全。",
                    ],
                    list2: [
                        "核心技术领先，在运行3D软件、各类CAX软件时能获得最高4K@60hz，端到端延时低至40ms的高清流畅体验。",
                        "弹性、多规格的图形计算实例，可快速部署使用。",
                        "支持GPU虚拟化+工作站托管，节约成本。",
                    ],
                    pic: pic1,
                },
                {
                    key: 1,
                    tabTitle: "信创访问场景",
                    icon: icon22,
                    active: icon2Active,
                    title: "使用信创设备进行办公的场景",
                    list1: [
                        "适用于使用信创设备/系统进行办公的场景。 ",
                        "传统的云桌面1.0主要关注对于Windows系统的虚拟化，以及基于常见系统和终端发起访问；对于信创系统和芯片的兼容，缺乏改造经验、改造工具，存在多重挑战。",
                    ],
                    list2: [
                        "全面兼容中国芯, 适配飞腾、鲲鹏、兆芯、海光、海思麒麟等国产CPU；",
                        "全面支持统信UOS、银河麒麟、中科方德等操作系统；",
                        "支持虚拟应用，提供终端应用过渡能力，平滑演进信创云建设。 ",
                    ],
                    pic: pic2,
                },
                {
                    key: 2,
                    tabTitle: "外部访问场景",
                    icon: icon33,
                    active: icon3Active,
                    title: "企业多地办公、出差员工远程访问的场景 ",
                    list1: [
                        "适用于公司多分支机构、分布式办公、出差办公、居家办公等办公场景，例如大型企业在各地的分公司等。",
                        "外部访问中，企业首先关注数据安全不落地；与此同时，企业用户希望可以随时随地使用各类设备接入云桌面，轻松实现远程安全办公。",
                    ],
                    list2: [
                        "接入便捷，支持跨系统（Windows、Mac、Linux、Android、iOS）、跨终端（PC、Pad、手机）、跨架构（广泛支持x86&Arm架构，同时深度兼容信创系统及芯片）发起访问；",
                        "搭配Zuler OTT SD-WAN外网加速，外网也能随时随地流畅办公；",
                        "在手机、平板等移动终端的交互上进行专项优化，触屏亦能流畅操控。",
                    ],
                    pic: pic3,
                },
                {
                    key: 3,
                    tabTitle: "临时使用场景",
                    icon: icon44,
                    active: icon4Active,
                    title: "短期使用的场景",
                    list1: [
                        "适用于公司外包、暑期实习、供应商支持等临时短期使用场景，以及图书馆、云教室、呼叫中心等公用终端场景。",
                        "在公用桌面场景中，用户关注桌面办公环境能否迅速搭建和回收。",
                    ],
                    list2: [
                        "云桌面即开即用，支持弹性扩容，资源随需快速创建。",
                        "同时配置规格丰富，可满足不同人群的需求。",
                        "虚拟桌面+远程物理桌面，一个系统统一管理，运维管理简单高效。",
                    ],
                    pic: pic4,
                },
                {
                    key: 4,
                    tabTitle: "数据安全管控场景",
                    icon: icon55,
                    active: icon5Active,
                    title: "数据安全管控场景",
                    list1: [
                        "适用于企事业核心机构、银行办公、研发中心、软件开发外包管理、供应商上下游办公等各类安全办公场景。",
                        "以上安全办公场景中，对数据和设计资料有保密要求，需防止泄漏。",
                    ],
                    list2: [
                        "所有数据都保存在服务器，在本地客户端上不保存，仅通过加密的Desktron音视频传输协议做视频流展示。",
                        "23项安全措施，实现事前数据不落地、事中过程可记录、事后行为可溯源。",
                    ],
                    pic: pic5,
                },
            ]),

            active: 0,
        };
    },
    methods: {
        handleClick() {
            this.$router.push({
                path: this.path,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.Scenes {
    ::v-deep .van-tabs--line .van-tabs__wrap {
        position: relative;
        height: 45px;

        &::after {
            position: absolute;
            content: "";
            left: 0;
            right: 0;
            bottom: 0;
            height: 1px;
            background-color: #0000001a;
        }

        .van-tab--active {
            position: relative;

            &::after {
                position: absolute;
                content: "";
                left: 0;
                right: 0;
                bottom: 0;
                height: 2px;
                background-color: #0c89e4;
            }
        }

        .van-tabs__line {
            width: 0;
            height: 0;
        }

        .van-tab {
            width: auto;
            margin-right: 10px;
            padding: 0 6px;
            font-size: 14px;
        }
    }
}

.common-title {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    padding: 40px 0 30px;
    line-height: 34px;
    color: #1d2129;
}

.common-title1 {
    padding-bottom: 8px;
}

.btn-common {
    display: block;
    box-sizing: border-box;
    width: 256px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid rgba(105, 116, 167, 0.22);
    background: #fff;
    color: #0c89e4;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #ecf6fd;
        border-color: #0c89e4;
    }

    &:active {
        background-color: #ecf6fd;
        border-color: #0c89e4;
    }
}

.btn-common+.btn-common {
    margin-left: 18px;
}

.btn-primary {
    background-color: #0c89e4;
    color: #ffffff;
    border-color: #0c89e4;

    &:hover {
        background-color: #2495e7;
        border-color: #2495e7;
    }

    &:active {
        background-color: #0b7bcd;
        border-color: #0b7bcd;
    }
}

.dt-func {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 18px 15px 20px;
}

.dt-btn {
    position: relative;
    margin: 0 auto;
}

.Scenes-right {
    height: 264px;
    margin: 24px 0;
}

.Scenes-title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;
    margin: 0 20px;
}

.Scenes-list1 {
    margin: 14px 20px 24px;
}

.Scenes-list2 {
    margin: 12px 20px 30px;
}

.Scenes-item1 {
    position: relative;
    padding-left: 24px;
    font-size: 14px;
    color: #4e5969;
    line-height: 1.4;
    margin-bottom: 14px;

    &:last-child {
        margin-bottom: 0;
    }

    &::before {
        content: "";
        position: absolute;
        top: 7px;
        left: 0;
        width: 8px;
        height: 8px;
        background-color: #0c89e4;
        border-radius: 50%;
    }
}

.Scenes-item2 {
    position: relative;
    padding-left: 24px;
    font-size: 14px;
    color: #4e5969;
    line-height: 1.4;
    margin-bottom: 14px;

    &:last-child {
        margin-bottom: 0;
    }

    &::before {
        content: "";
        position: absolute;
        top: 1px;
        left: 0;
        width: 16px;
        height: 16px;
        background: url("~@/assets/desktron/Scenes/right.png") center no-repeat;
        background-size: 100% auto;
    }
}

.Scenes-item {
    display: flex;
    align-items: center;
}

.Scenes-item-img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
}

.Scenes {
    position: relative;
    // background: #f7faff;
    padding-bottom: 40px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 179px;
        height: 220px;
        // background: url("~@/assets/desktron/Scenes/half1.png") center no-repeat;
        background-size: 100% 100%;
    }

    .Scenes-after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 288px;
        // background: url("~@/assets/desktron/Scenes/half2.png") center no-repeat;
        background-size: 100% 100%;
    }
}</style>